<template>
  <div class="newsContent">
    <div
      class="newsContent-article"
      id="imageWrapper"
      ref="imageWrapper"
      v-if="canvasImageUrl == ''"
    >
      <img class="imgShow" width="100%" :src="`${url}${item.imageCoverName}`" ref="selfReport">
      <div class="newsContent-article-box">
        <h3>{{zLocale == 'en' ? item.titleEn == '' || item.titleEn == null ? item.title : item.titleEn : item.title}}</h3>
        <span>{{item.publishTime | dateFormat('MM / DD / YYYY')}}</span>
        <div
          class="content"
          v-html="zLocale == 'en' ? item.contentEn == '' || item.contentEn == null ? item.content : item.contentEn : item.content"
        ></div>
        <div class="QrCode">
          <p>— 扫码立即前往 —</p>
          <QrCode ref="QrCode" :id="'QrCode'" :text="codeUrl" />
        </div>
      </div>
    </div>
    <div class="canvasImg">
      <transition name="van-fade" v-if="canvasImageUrl">
        <div class="close iconfont"
              @click="showCanvas">&#xe60f;
        </div>
      </transition>
      <img style="width: 100%;" @load='imgOnError' :src="canvasImageUrl">
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import QrCode from '@/components/qrCode'  // 引用上面封装的二维码组件

import html2canvas from 'html2canvas' //把html生成图片
// import QRCode from 'qrcodejs2' //生成二维码图片
// import { StringDecoder } from 'string_decoder'

export default {
  name: 'DetailContent',
  props: {
    item: {
      //这个就是父组件中子标签自定义名字
      type: Object,
      required: true,
    },
    // loadingDetailCanvas: {
    //   type: Boolean
    // }
  },
  data() {
    return {
      url: this.$store.state.baseURL + '/',
      canvasImageUrl: '',
      loadingDetailCanvas: false,
      codeUrl: ''  // 后端返回的二维码地址
    }
  },
  components: { QrCode },
  computed: {
    ...mapState({
      zLocale: (state) => state.locale,
    }),
    // qrCodeSrc() {
    //   if (this.$refs['QrCode'].$el.children[1].getAttribute('src')) {
    //     console.log('this.$refs[this.id]', this.$refs['QrCode'].$el.children[1].getAttribute('src'))
    //     return true
    //   } else {
    //     return false
    //   }
    // }
  },
  mounted() {
    this.codeUrl = `https://www.kamlung.com/news/detail/${this.item.id}?lang=${this.zLocale}`
    this.$_isFixed(false)
    this.$nextTick(() => {
      setTimeout(() => {
        this.productionImage()
      }, 3000)
    })
  },
  methods: {
    ...mapMutations(['$_isFixed']),
    showCanvas() {
      this.$emit('onDetailCanvasFun', false)
    },
    productionImage() {
      // 手动创建一个 canvas 标签
      const canvas = document.createElement('canvas')
      // 获取父标签，意思是这个标签内的 DOM 元素生成图片
      let canvasBox = this.$refs.imageWrapper
      // 获取父级的宽高
      const width = parseInt(window.getComputedStyle(canvasBox).width)
      const height = parseInt(window.getComputedStyle(canvasBox).height)

      // 宽高 * 2 并放大 2 倍 是为了防止图片模糊
      canvas.width = (width > 460 ? 460 : width) * 2
      canvas.height = height * 2
      canvas.style.width = width + 'px'
      canvas.style.height = height + 'px'

      const context = canvas.getContext('2d')
      context.scale(1, 1)

      const options = {
        backgroundColor: '#ffffff',
        canvas: canvas,
        useCORS: true,
        scale: 2
      }
      html2canvas(canvasBox, options).then((canvas) => {
        // toDataURL 图片格式转成 base64
        let dataURL = canvas.toDataURL('image/png')
        this.canvasImageUrl = dataURL
        this.$emit("canvasImageFun", this.canvasImageUrl) //传递值“子向父组件传值”

        // this.downloadImage(dataURL)
      })
    },
    imgOnError(e) {
      this.loadingDetailCanvas = true
    },
    downloadImage(url) {
      // 创建一个 img 标签，把图片插入到 DOM 中
      // 这里使用 img 是因为在客户端中，不能直接下载，要调用原生的方法
      const parents = this.$refs.selfReport
      const createImg = document.createElement('img')
      const insertEle = this.$refs.insetElement
      parents.insertBefore(createImg, parents.childNodes[0])

      createImg.setAttribute('src', url)

      // 如果是在网页中可以直接创建一个 a 标签直接下载
      let a = document.createElement('a')
      a.href = url
      a.download = '文件名'
      a.click()
    },
  },
  watch: {
    '$route.params.id': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) this.$_isFixed(false)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../static/stylebody.css';
* >>> table {
  margin-top: 10px;
}
.canvasImg {
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
.QrCode {
  padding: 18px 0 18px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    font-size: 20px;
    margin-bottom: 10px;
  }
}
.newsContent {
  margin-top: 0px;
  &-article {
    width: 100%;
    // visibility: hidden;
    // position: relative;
    // top: 0;
    // left: 0;
    padding: 0;
    margin-bottom: 20px;
    &-topbg {
      width: 100%;
      height: 550px;
      background-size: cover;
    }
    &-return {
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      width: 100%;
      font-size: 16px;
      color: $color-grey-1;
      em {
        margin-right: 10px;
        font-size: 16px;
      }
    }
    &-box {
      padding: 0 6px;
      margin-top: 18px;
      display: inline-block;
      width: 100%;
      h3 {
        margin-bottom: 26px;
        font-size: 27px;
      }
      span {
        margin-bottom: 36px;
        position: relative;
        display: block;
        font-size: 14px;
        color: $color-grey-2;
      }
      .content {
        width: 100%;
        /deep/ img {
          // width: 100%;
          cursor: pointer;
        }
      }
      &-tool {
        padding: 40px 0;
        border-bottom: $border-bottom-1;
        h4 {
          font-size: 20px;
          margin-bottom: 24px;
        }
        ul {
          margin-bottom: 24px;
          display: flex;
          li {
            margin-right: 24px;
            font-size: 16px;
            text-align: center;
            width: 144px;
            height: 42px;
            line-height: 42px;
            border: $border-1;
          }
        }
        ol {
          display: flex;
          li {
            margin-right: 52px;
            font-size: 33px;
          }
        }
        &-share {
          margin-top: 50px;
        }
      }
    }
    &-newsLi {
      margin-right: 20px;
      width: calc(33.33% - 10px);
      display: flex;
      align-items: center;
      color: #333;
      cursor: pointer;
      &:nth-of-type(3n) {
        margin-right: 0;
      }
      &-img {
        // width: 180px;
        width: 34%;
        img {
          width: 100%;
        }
      }
      &-text {
        width: 66%;
        margin-left: 10px;
        h4 {
          font-size: 18px;
          line-height: 24px;
        }
        span {
          display: block;
          font-size: 16px;
          margin-bottom: 10px;
        }
      }
    }
  }
  &-dis {
    padding: 34px 0 !important;
    margin-bottom: 0;
    display: flex;
  }
  &-page {
    margin-bottom: 120px;
  }
}
@media (max-width: 500px) {
  img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/news/DetailContent.vue